import type { FaviconScenario } from "owa-favicon";
import { TabType } from "owa-tab-store";

export default function getProjectionFaviconScenario(tabType: TabType): FaviconScenario | undefined {
    switch (tabType) {
        case TabType.SecondaryReadingPane:
            return "MailRead";
        case TabType.MailCompose:
            return "MailCompose";
        case TabType.CalendarCompose:
        case TabType.CalendarReadingPane:
            return "Calendar";
        case TabType.Reminders:
            return "Reminder";
        default:
            return undefined;
    }
}
